import { render, staticRenderFns } from "./wxpay_mini.vue?vue&type=template&id=735415aa&scoped=true"
import script from "./wxpay_mini.vue?vue&type=script&lang=js"
export * from "./wxpay_mini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735415aa",
  null
  
)

export default component.exports